import React from 'react';
import { GreenMarker, YellowMarker, RedMarker } from './../assets';
const MapLegend = ({ levelInformation, setSelectedColor, selectedColor }) => {
  let yellow = 0;
  let red = 0;

  if (levelInformation) {
    yellow = levelInformation['yellow'];
    red = levelInformation['red'];
  }
  return (
    <div
      style={{
        backgroundColor: 'white',
        marginLeft: '1em',
        padding: '20px',
        borderRadius: '8px',
      }}
      className='MapLegend'>
      <h1>Legend</h1>
      <div
        onClick={() => {
          setSelectedColor('green');
        }}>
        <img
          style={{ cursor: 'pointer', marginRight: '4em' }}
          src={GreenMarker}
          alt='Green Marker'
        />
        {`<${yellow}%`}{' '}
      </div>
      <div
        onClick={() => {
          setSelectedColor('yellow');
        }}>
        <img
          style={{ cursor: 'pointer', marginRight: '3.2em' }}
          src={YellowMarker}
          alt='Yellow Yellow'
        />
        {`${yellow}-${red}%`}
      </div>
      <div
        onClick={() => {
          setSelectedColor('red');
        }}>
        <img
          style={{ cursor: 'pointer', marginRight: '1.1em' }}
          src={RedMarker}
          alt='Red Marker'
        />
        {`>${red}%/Alarm`}
      </div>
      &nbsp;
      <div style={{ cursor: 'pointer' }}>
        {selectedColor ? (
          <span
            onClick={() => {
              setSelectedColor(false);
            }}>
            Cancel Filter
          </span>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
};

export default MapLegend;
